import { createFileRequest, createJSONRequest, createPagedRequest } from './create-request'
import querify from '../util/querify'

export const fetchProspects = (filters) =>
  createPagedRequest({ url: `/api/settings/outreach/prospects?${querify(filters)}` })

export const importProspects = (formData) =>
  createFileRequest({ url: '/api/settings/outreach/prospects/import', method: 'POST', body: formData })

export const sendOutreach = (data) =>
  createJSONRequest({ url: '/api/settings/outreach/prospects/send', method: 'POST', data })

export const fetchAnalytics = (filters) =>
  createPagedRequest({ url: `/api/settings/outreach/analytics?${querify(filters)}` })

export const fetchOutreachConfig = () =>
  createJSONRequest({ url: '/api/settings/outreach/config', method: 'GET' })

export const saveOutreachConfig = (data) =>
  createJSONRequest({ url: '/api/settings/outreach/config', method: 'PUT', data })

export const saveScoreCategories = (data) =>
  createJSONRequest({ url: '/api/settings/outreach/config/score-categories', method: 'PUT', data })

export const sendTestEmail = (data) =>
  createJSONRequest({ url: '/api/settings/outreach/config/test-email', method: 'POST', data })
